// Deciding an approval (or sending one) moves the Approval badges and Home's
// approvals card. The screens that do it call the services directly or
// through several thunks, so the services announce it and the badges' owner
// reads the lists again.
const listeners = new Set<() => void>()

export const onApprovalsChanged = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** Passes the write's answer through, announcing it once it succeeded. */
export const announcesApprovalChange = <T extends { ok?: boolean } | null>(
  write: Promise<T>
): Promise<T> => {
  void Promise.resolve(write).then(
    (response) => {
      if (response?.ok) listeners.forEach((listener) => listener())
    },
    () => {}
  )
  return write
}
